import classNames from "classnames";
import { AnimatePresence, motion } from "framer-motion";
import Image from "next/image";
import React, { FC, useContext, useEffect, useState } from "react";

import { TemplateContext } from "@/context/TemplateContext";
import useMediaQuery from "@/hooks/useMediaQuery";

import { HistoryCard } from "./types";

interface Props {
  currentCard: HistoryCard;
  currentYearGroupIndex: number;
}
const HistoryBgImage: FC<Props> = ({ currentCard, currentYearGroupIndex }) => {
  const { fixedHeader } = useContext(TemplateContext);

  const [image, setImage] = useState({
    md: currentCard.backgroundImage?.url,
    sm: currentCard.mobileBackgroundImage?.url,
    alt: currentCard.backgroundImage?.title,
  });
  const [activatorKey, setActivatorKey] = useState(0);

  const isMobile = useMediaQuery("(max-width: 1023px)");

  useEffect(() => {
    setImage({
      md: currentCard.backgroundImage?.url,
      sm: currentCard.mobileBackgroundImage?.url,
      alt: isMobile && currentCard.mobileBackgroundImage?.title ? currentCard.mobileBackgroundImage?.title : currentCard.backgroundImage?.title,
    });
    setActivatorKey(activatorKey + 1);
  }, [currentCard, isMobile]);

  return (
    <div className="absolute top-0 h-full w-full md:w-screen">
      <div
        className={classNames(
          "relative md:sticky h-[calc(100%-56px)] w-full",
          { "md:h-[calc(100vh-var(--header-height))] md:top-[var(--header-height)]": !fixedHeader },
          { "top-0 md:h-screen": fixedHeader },
        )}
      >
        <AnimatePresence>
          <motion.div
            key={activatorKey}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              opacity: { duration: 0.7 },
            }}
          >
            <div className="absolute h-full w-full">
              <picture>
                {image.sm && <source media="(max-width: 1023px)" srcSet={image.sm} />}
                {image && <Image src={image.md} data-slide={currentYearGroupIndex} alt={image.alt || ""} fill className="object-cover" />}
                {isMobile && <div className="img-overlay-5 absolute top-0 left-0 bottom-0 right-0"></div>}
              </picture>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};
export default HistoryBgImage;
